import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import validationUtils from "../../../../../../utils/ValidationUtils";
import { TOTAL_CONTACTS } from "../helpers/contactDataHelper";
import StrategicContactFields from "./StrategicContactFields";

const LINKEDIN_REGEX = /^$|^https:\/\/(www\.)?linkedin\.com\/in\/[A-Za-z0-9À-ÿäöüßÆæœŒ\-\~%]{3,}(\/)?$/u;
class StrategicContactForm extends React.Component {
    static generateLocalizedRules(values) {
        const rules = {};
        TOTAL_CONTACTS.forEach((val) => {
            const roleKey = `role-${val}`;
            const isRoleFilled = values[roleKey] && values[roleKey].trim() !== "";
            // If the role is not filled, apply rules to firstName and lastName
            if (isRoleFilled == true) {
                ["firstName", "lastName"].forEach((field) => {
                    const key = `${field}-${val}`;
                    const value = (values[key] && values[key].trim()) || "";
                    // If the field is missing or empty, mark it as required
                    if (value === "") {
                        rules[key] = {
                            isRequiredTrim: {
                                value: true,
                            },
                        };
                    }
                });
            }
            rules[`emailAddress-${val}`] = {
                regex: {
                    value: {
                        pattern: /^$|^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
                        customMessageKey: "validation.customMessages.emailAddressRegex",
                    },
                },
            };
            rules[`linkedin-${val}`] = {
                regex: {
                    value: {
                        pattern: LINKEDIN_REGEX,
                        customMessageKey: "clientContacts.form.strategicContact.linkedInWebsiteRegex",
                    },
                },
            };

            rules[`note-${val}`] = {
                maxLength : {
                    value: 500
                }
            };
            
            rules[`title-${val}`] = {
                isRequiredTrimIfFieldHasValue: {
                    value: {
                        field: roleKey,
                        expectedValues: ["OTHER"],
                    },
                },
            };
        });
        return rules;
    }

    constructor(props, context) {
        super(props, context);
    }
    render() {
        const {
            handleSubmit,
            submittingForm,
            keysToPost,
            client,
            disabled,
            archiveClientContact,
            clearValues,
            changeFieldValue,
        } = this.props;
        return (
            <div className="strategic-contact-form">
                <form onSubmit={handleSubmit}>
                    <h3>
                        <FormattedMessage id="clientContacts.form.strategicContact.title" />
                    </h3>
                    <div className="client-contact">
                        {this.props.clientContacts && this.props.clientContacts.map((initialValue, index) => (
                            <StrategicContactFields
                                id={index}
                                key={index}
                                submittingForm={submittingForm}
                                initialValues={initialValue}
                                client={client}
                                disabled={disabled}
                                blockDeleteRole={!initialValue.clientContactId}
                                emptyRole={!initialValue.role}
                                index={index}
                                changeFieldValue={changeFieldValue}
                                archiveClientContact={archiveClientContact}
                                keysToPost={keysToPost}
                                clearValues={clearValues}
                                linkedinRegex={LINKEDIN_REGEX}
                            />))}
                    </div>
                    <button disabled={submittingForm || disabled} type="submit" className="btn btn-lg btn-primary">
                        <FormattedMessage id="clientContacts.form.operationalContact.save" />
                    </button>
                </form>
            </div>
        );
    }
}

StrategicContactForm.propTypes = {
    client: PropTypes.object.isRequired,
    clientContacts: PropTypes.array.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    dataActions: PropTypes.object.isRequired,
    changeFieldValue: PropTypes.func.isRequired,
    clearValues: PropTypes.func.isRequired,
    submittingForm: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    archiveClientContact: PropTypes.func.isRequired,
    keysToPost: PropTypes.array.isRequired,
};

export default connect(null, null, null, {
    withRef: true,
})(
    reduxForm({
        form: "strategicContactForm",
        validate: (values) => validationUtils.validate(values, StrategicContactForm.generateLocalizedRules(values)),
    })(StrategicContactForm)
);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/contacts/strategic-contacts/StrategicContactForm.js